import { useMemo } from "react";
import { Product } from "@/services/productService";

const useIsProductMultisize = (product: Product) => {
  return useMemo(() => {
    return product.isMultisize;
  }, [product]);
};

export default useIsProductMultisize;
